import { render, staticRenderFns } from "./LimitedSubscriptionList.vue?vue&type=template&id=68aa281a&"
import script from "./LimitedSubscriptionList.vue?vue&type=script&lang=js&"
export * from "./LimitedSubscriptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports